import type { ReactNode } from 'react';

import { cn } from '../../lib/cn';
import styles from './Page.module.css';

export type PageSectionProps = {
  readonly title?: ReactNode;
  readonly className?: string;
  readonly children: ReactNode;
};

/** Секция страницы: одинаковые поля, рамка и ритм внутри. */
export function PageSection({ title, className, children }: PageSectionProps) {
  return (
    <section className={cn(styles['section'], className)}>
      {title ? <h2 className={styles['sectionTitle']}>{title}</h2> : null}
      {children}
    </section>
  );
}
